import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';
import cloneDeep from 'lodash/cloneDeep';

/**
 * Component for managing a user's search options.
 */
@Component({
	selector: 'user-search-opts',
	templateUrl: './search-opts.component.html',
	styleUrl: './search-opts.component.css'
})
export class SearchOptsComponent implements OnInit {

	LOCALIZATION: any;

	searchPrefs: any[] = [];
	queryPrefs = [
		'QUERY_TYPE',
		'MAX_FUZZY_SPELL_PROPERTY',
		'DEFAULT_SEARCH_COORD_TYPE'
	];

	constructor(
		private alertsService: AlertsService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadSearchOpts();
	}

	private loadSearchOpts(): void {
		let prefs = cloneDeep(this.userService.user.properties.awpropertyObjectList);
		this.searchPrefs = prefs.sort((a: any, b: any) => a.displayName.localeCompare(b.displayName));
	}

	updatePreferences(): void {
		let prefs = {
			awpropertyObjectList: this.userService.user.properties.awpropertyObjectList,
			awsortObjectList: this.userService.user.properties.awsortObjectList,
			awfieldObjectList: this.userService.user.properties.awfieldObjectList,
			awfieldCollectionObjectList: this.userService.user.properties.awfieldCollectionObjectList,
			awlibraryObjectList: this.userService.user.properties.awlibraryObjectList
		};

		for (var i = 0; i < this.queryPrefs.length; i++) {
			var property = this.queryPrefs[i];
			var value = '';
			for (var j = 0; j < this.searchPrefs.length; j++) {
				if (this.searchPrefs[j].name == property) {
					for (var k = 0; k < prefs.awpropertyObjectList.length; k++) {
						if (prefs.awpropertyObjectList[k].name == property) {
							prefs.awpropertyObjectList[k].value = this.searchPrefs[j].value;
							break;
						}
					}
					break;
				}
			}
		}

		let cleanedPrefs = this.userService.cleanData(prefs);

		let payload = {
			prefs: JSON.stringify(cleanedPrefs)
		};

		this.userService.updateUser(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.userProfileUpdateSuccess,
					delay: 5000
				});
			},
			(err: any) => {
				console.error("Failed to update user details.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.userProfileUpdateError,
					delay: 5000
				});
			}
		);
	}
}
